"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'HeaderFilter',
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    labels: {
      // ['timeType', 'brand', 'time']
      type: Array,
      default: function _default() {
        return [];
      }
    },
    hideTimeTypeLabel: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ssbtypeOptions: function ssbtypeOptions() {
      return [{
        name: this.$t('dashboard.GY'),
        code: 'GY'
      }, {
        name: this.$t('dashboard.CP'),
        code: 'CP'
      }];
    },
    // 时间lable格式化
    formatTimeLabel: function formatTimeLabel() {
      var tree = {
        1: this.$t('storeComponents.select.month'),
        2: this.$t('storeComponents.select.quarter'),
        3: this.$t('storeComponents.select.year')
      };
      var type = this.value.type;
      if (type && tree[type]) {
        return tree[type];
      } else {
        return '';
      }
    }
  }
};